import React from 'react'

const Education = () => {
    return (
        <div className="education-div" data-aos="fade-in" data-aos-duration="2000">
            <div className="education-imfo">
                <div className="College">
                    <h4><span>AJAY KUMAR GARG ENGINEERING COLLEGE</span></h4>
                    <p>Bachelor of Technology</p>
                    <p>2019 - 2023</p>
                </div>
                <div className="School">
                    <h4><span>ST. THOMAS COLLEGE</span></h4>
                    <p>High School & Intermediate</p>
                    <p>2016 - 2018</p>
                </div>
            </div>
        </div>
    )
}

export default Education
